import React from 'react';
import Table from '../Table/Table'


export default function LoadBaseProspects() {
    const colums = [
        {
            Header: "A",
            accessor: "ID"
        },
        {
            Header: "B",
            accessor: "NOMBRE"
        },
        {
            Header: "C",
            accessor: "DNI"
        },
        {
            Header: "D",
            accessor: "CUIT"
        },
        {
            Header: "E",
            accessor: "SEXO"
        },
        {
            Header: "F",
            accessor: "TELEFONO1"
        },
        {
            Header: "G",
            accessor: "TELEFONO2"
        },
        {
            Header: "H",
            accessor: "EMAIL"
        },
        {
            Header: "I",
            accessor: "PARTIDO"
        },
        {
            Header: "J",
            accessor: "OFERTA"
        },
        {
            Header: "K",
            accessor: "CAMPANIA"
        },
        {
            Header: "L",
            accessor: "VENDEDOR"
        },
        {
            Header: "M",
            accessor: "ORDEN"
        },
    ]

    const data = [
        {
            ID: "ID",
            NOMBRE: "NOMBRE",
            DNI: "DNI",
            CUIT: "CUIT",
            SEXO: "SEXO",
            TELEFONO1: "TELEFONO1",
            TELEFONO2: "TELEFONO2",
            EMAIL: "EMAIL",
            PARTIDO: "PARTIDO",
            OFERTA: "OFERTA",
            CAMPANIA: "CAMPANIA",
            VENDEDOR: "VENDEDOR",
            ORDEN: "ORDEN",
        },
        {
            ID: 1000,
            NOMBRE: "Rosa Gómez",
            DNI: 3555000,
            CUIT: 2025550001,
            SEXO: "F",
            TELEFONO1: "384-22221111",
            TELEFONO: "384-11115555",
            EMAIL: "prospecto@test.com.ar",
            PARTIDO: "",
            OFERTA: "PRESTAMO PRE-APROBADO DE $7000",
            CAMPANIA: "PRESTAMOS",
            VENDEDOR: "",
            ORDEN: "",
        },
        {
            ID: 1000,
            NOMBRE: "Rosa Gómez",
            DNI: 3555000,
            CUIT: 2025550001,
            SEXO: "F",
            TELEFONO1: "384-22221111",
            TELEFONO: "384-11115555",
            EMAIL: "prospecto@test.com.ar",
            PARTIDO: "",
            OFERTA: "PRESTAMO PRE-APROBADO DE $7000",
            CAMPANIA: "PRESTAMOS",
            VENDEDOR: "",
            ORDEN: "",
        },
    ]

    return (
        <div className="relative flex flex-col gap-4">
            <div className="bg-white rounded-xl shadow-[0_4px_10px_rgba(0,0,0,0.03)] p-6">
                <h1 className="text-2xl font-bold">Cargar Base</h1>
                <p className='my-10'>Los campos esperados son: id, nombre, dni, cuit, sexo, teléfono1, teléfono2, email, partido, oferta, campania, vendedor asignado (opcional) y orden (opcional).</p>
                <p>La primera fila pertenece a los títulos.</p>
                <div className='flex gap-4 mt-5'>
                    <div className='flex-1'>
                        <p>Si son varias campañas se seleccionan el campo campaña de cada fila</p>
                        <select name="sucursal" id="sucursal" className="w-full p-2 rounded-lg border border-gray-300">
                            <option value="" selected disabled>Campana</option>
                            <option value="">1</option>
                            <option value="">2</option>
                            <option value="">3</option>
                        </select>
                    </div>
                    <div className='flex-1'>
                        <p>Cargar el archivo en formato <b>CSV</b></p>
                        <input type="file" />
                    </div>
                </div>
            </div>

            <Table columns={colums} data={data} showGlobalFilter={false} pagination={false} />
        </div>
    )
}


